// Based on the guide "Vue.js Authentication 2 By Example": https://developer.auth0.com/resources/guides/spa/vue/basic-authentication/v2-javascript

import { getInstance } from "@/auth0-plugin";

export const authenticationGuard = (to, from, next) => {
  const authService = getInstance();

  const guardAction = () => {
    if (authService.isAuthenticated) {
      // Check whether the user is authorized to view the route
      if (to.meta && to.meta.authorizedRoles) {
        const roles = authService.user[process.env.VUE_APP_AUTH0_CUSTOM_CLAIM_NAMESPACE + '/roles'];
        for (const role of roles) {
          if (to.meta.authorizedRoles.includes(role)) {
            return next();
          }
        }
        // The user is not authorized
        return next(false);
      }
      return next();
    }

    authService.loginWithRedirect({ appState: { targetPath: to.fullPath } });
  };

  // If the Auth0Plugin has loaded already, check the authentication state
  if (!authService.isLoading) {
    return guardAction();
  }

  authService.$watch("isLoading", (isLoading) => {
    if (isLoading === false) {
      return guardAction();
    }
  });
};
